/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'GoalPanel.header.title': '目標',
  'goal-panel.generic-error.description': '請檢查您的網際網路連線，然後再試一次。',
  'goal-panel.generic-error.title': '發生錯誤',
  'goal-panel.goal-panel-expand-field-button.show-less-collapsed-label': '顯示更多欄位',
  'goal-panel.goal-panel-expand-field-button.show-more-collapsed-label': '顯示較少',
  'goal-panel.goal-panel-tabs.about-tab-title': '關於',
  'goal-panel.goal-panel-tabs.jira-align-title': 'Jira Align',
  'goal-panel.goal-panel-tabs.jira-title': 'Jira',
  'goal-panel.goal-panel-tabs.projects-title': '專案',
  'goal-panel.goal-panel-tabs.updates-tab-title': '更新',
  'goal-panel.goal-title.edit-button-label': '編輯目標的標題',
  'goal-panel.goal-title.update-error-description': '無法更新 {goalName} 的內容',
  'goal-panel.goal-title.update-error-title': '發生錯誤',
  'goal-panel.goal-title.validation-message': '請為您的目標指定標題',
};
